import React, { useEffect, useState } from "react";

const useTimer = (createdDate) => {
  const [currentTimer, setCurrentTimer] = useState("");
  const [lightColor, setLightColor] = useState("");

  useEffect(() => {
    const timer = setInterval(updateTimer, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  function updateTimer() {
    const targetDate = new Date(createdDate);
    const ausDate = new Date()
      .toLocaleString("en-US", { timeZone: "Australia/Melbourne" })
      .toString();
    const currentDate = new Date(ausDate);

    // const timeDifference = targetDate - currentDate;
    const timeDifference = currentDate - targetDate;

    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor(
      (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    setCurrentTimer(
      days > 0
        ? `${days} : ${hours} : ${minutes} : ${seconds}`
        : hours > 0
        ? `${hours} : ${minutes} : ${seconds}`
        : `${minutes} : ${seconds}`
    );

    if (days < 1 && hours < 1 && minutes < 5) {
      setLightColor("#9FE2BF");
    } else if (days < 1 && hours < 1 && minutes < 7 && minutes > 5) {
      setLightColor("#FFD580");
    } else if (days < 1 && hours < 1 && minutes < 8 && minutes > 7) {
      setLightColor("#ffcccb");
    } 
    // else if (minutes < 9 && minutes > 8) {
    //   setLightColor("dark_red");
    // } 
    else if (days < 1 && hours < 1 && minutes > 10) {
      setLightColor("#ff9693");
    }else{
      setLightColor("#ff9693");
    }
  }

  return {currentTimer,lightColor};
};

export default useTimer;
